export const trainingRoute = [
  {
    path: "/kanban",
    name: "Kanban",
    component: () => import("@/views/Training/Kanban/Kanban.vue"),
  },
  {
    path: "/coursedetail/:courseID",
    name: "CourseDetail",
    component: () => import("@/views/Training/CourseDetail/CourseDetail.vue"),
  },
  {
    path: "/courseview/:courseID",
    name: "CourseView",
    component: () => import("@/views/Training/CourseView/CourseView.vue"),
  },
  {
    path: "/community",
    name: "Community",
    component: () => import("@/views/Training/Community/Community.vue"),
  },
  {
    path: "/certificates",
    name: "Certificates",
    component: () => import("@/views/Training/Certificates/Certificates.vue"),
  },
];
